export enum DashboardWidgetBlock {
  Root = 'DashboardWidget',
}

export enum DashboardWidgetElement {
  Content = 'content',
  NoData = 'noData',
}
